import LoginPage from "beaktShared/views/GenericPages/LoginPage.js";
import UserProfile from "beaktShared/views/GenericPages/UserProfile.js";
import Home from "beaktClinic/views/Home.js";
import Dashboard from "beaktClinic/views/Dashboard/Dashboard.js";
import Venda from "beaktClinic/views/Venda/Venda.js";
import VendasEmAndamento from "beaktClinic/views/Venda/VendasEmAndamento";
import CarrinhoVenda from "beaktClinic/views/Venda/CarrinhoVenda.js";
import IdentificacaoVenda from "beaktClinic/views/Venda/IdentificacaoVenda";
import PagamentoVenda from "beaktClinic/views/Venda/PagamentoVenda";
import FinalizacaoVenda from "beaktClinic/views/Venda/FinalizacaoVenda";
import Avaliacao from "beaktClinic/views/Avaliacao/Avaliacao";
import AvaliacoesPendentes from "beaktClinic/views/Avaliacao/AvaliacoesPendentes";
import ProdutoGrupo from "beaktShared/views/Cadastros/ProdutoGruposList.js";
import Produto from "beaktShared/views/Cadastros/ProdutosList.js";
import EspecialidadeList from "beaktShared/views/Cadastros/EspecialidadeList.js";
import ServicoList from "beaktShared/views/Cadastros/ServicoList.js";
import PacoteList from "beaktShared/views/Cadastros/PacoteList.js";
import FornecedorList from "beaktShared/views/Cadastros/FornecedoresList.js";
import GestaoClienteList from "beaktClinic/views/Clientes/GestaoClienteList.js";
import GestaoLeads from "beaktClinic/views/Clientes/GestaoLeads.js";
import GestaoListaNegraList from "beaktClinic/views/Clientes/GestaoListaNegraList.js";
import Agenda from "beaktDay/views/AdminAgenda/Agenda/Agenda.js";
import GestaoAgenda from "beaktDay/views/AdminAgenda/Agenda/GestaoAgenda.js";
import ProfissionalList from "beaktDay/views/AdminAgenda/Cadastros/ProfissionalList.js";
import ExpedienteList from "beaktDay/views/AdminAgenda/Cadastros/ExpedienteList.js";
import GestaoVendas from "beaktMatriz/views/Vendas/GestaoVendas.js";
import RoyaltiesList from "beaktClinic/views/Royalties/RoyaltiesList.js";
import ExtratoRoyalties from "beaktMatriz/views/Royalties/ExtratoRoyalties.js";
import PedidoCompra from "beaktClinic/views/Estoque/PedidoCompra.js";
import GestaoPedidoCompra from "beaktClinic/views/Estoque/GestaoPedidoCompra.js";
import RecebimentoCompra from "beaktMatriz/views/Estoque/RecebimentoCompra.js";
import AjusteEstoque from "beaktClinic/views/Estoque/AjusteEstoque.js";
import UsuarioList from "beaktShared/views/Seguranca/UsuarioList.js";
import AccessDenied from "beaktShared/views/Seguranca/AcessoNegado.js";
import ControleFinanceiro from "beaktClinic/views/Financeiro/ControleFinanceiro.js";
import BloqueioAgenda from "beaktDay/views/AdminAgenda/Agenda/BloqueioAgenda.js";
import DashboardAgenda from "beaktDay/views/AdminAgenda/Dashboard/Dashboard.js";
import RelatoriosPersonalizadosList from "beaktClinic/views/Relatorios/RelatoriosPersonalizadosList.js";
import RelatoriosSistemaList from "beaktClinic/views/Relatorios/RelatoriosSistemaList.js";
import GestaoCampanhaList from "beaktClinic/views/CRM/Campanhas/GestaoCampanhaList.js";
import AcompanhamentoCampanha from "beaktClinic/views/CRM/Acompanhamento/AcompanhamentoCampanha.js";
import SMTPForm from "beaktShared/views/Cadastros/SMTPForm";
import ProfissaoList from "beaktShared/views/Cadastros/ProfissaoList.js";
import CadastroChavePix from 'beaktShared/views/Cadastros/CadastroChavePix.js';
import MuralList from "beaktClinic/views/Mural/MuralList.js";
// @material-ui/icons
import Face from "@material-ui/icons/Face";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import Assignment from "@material-ui/icons/Assignment";
import Settings from "@material-ui/icons/Settings";
import BarChart from "@material-ui/icons/BarChart";
import DateRange from "@material-ui/icons/DateRange";
import CalendarToday from "@material-ui/icons/CalendarToday";
import Money from "@material-ui/icons/Money";
import WidgetsIcon from '@material-ui/icons/Widgets';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import Description from '@material-ui/icons/Description';
import Announcement from "@material-ui/icons/Announcement";
import { components } from "react-select/dist/react-select.cjs.prod";

var Routes = [
  {
    path: "/login",
    name: "login",
    mini: "L",
    component: LoginPage,
    layout: "/auth",
    showmenu: false
  },
  {
    path: "/user",
    name: "profile",
    mini: "MP",
    icon: Face,
    component: UserProfile,
    layout: "/adminclinic",
    showmenu: false
  },  
  {
    path: "/home",
    name: "home",
    mini: "H",
    component: Home,
    layout: "/adminclinic",
    showmenu: true
  },  
  {
    path: "/dashboard",
    name: "dashboard",
    mini: "H",
    icon: BarChart,
    component: Dashboard,
    layout: "/adminclinic",
    showmenu: true
  },
  {
    path: "/mural",
    name: "notice_board",
    icon: Announcement,
    component: MuralList,
    layout: "/adminclinic",
    showmenu: true
  },
  {
    collapse: true,
    name: "avaliation",
    icon: Assignment,
    state: "avaliacaoCollapse",
    views: [
      {
        path: "/avaliacao",
        name: "new_avaliation",
        mini: "AV",
        component: Avaliacao,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/avaliacoespendentes",
        name: "pending_avaliation",
        mini: "AP",
        component: AvaliacoesPendentes,
        layout: "/adminclinic",
        showmenu: true
      },
    ]
  },
  {
    collapse: true,
    name: "sales",
    icon: ShoppingCart,
    state: "vendasCollapse",
    views: [
      {
        path: "/venda",
        name: "new_sale",
        mini: "NV",
        component: Venda,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/vemandamento",
        name: "sales_progress",
        mini: "VA",
        component: VendasEmAndamento,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/gestaovendas",
        name: "sales_management",
        mini: "GA",
        component: GestaoVendas,
        layout: "/adminclinic",
        showmenu: true
      }      
    ]
  },
  {
    path: "/carrinhovenda",
    name: "sales_cart",
    mini: "C",
    component: CarrinhoVenda,
    layout: "/adminclinic",
    showmenu: false,
    pathFather:"/venda"
  }, 
  {
    path: "/identificacaovenda",
    name: "sales_identification",
    mini: "I",
    component: IdentificacaoVenda,
    layout: "/adminclinic",
    showmenu: false,
    pathFather:"/venda"
  }, 
  {
    path: "/pagamentovenda",
    name: "sale_payment",
    mini: "P",
    component: PagamentoVenda,
    layout: "/adminclinic",
    showmenu: false,
    pathFather:"/venda"
  }, 
  {
    path: "/finalizacaovenda",
    name: "sale_finalization",
    mini: "P",
    component: FinalizacaoVenda,
    layout: "/adminclinic",
    showmenu: false,
    pathFather:"/venda"
  },
  {
    collapse: true,
    name: "agenda",
    icon: CalendarToday,
    state: "agendaCollapse",
    views: [
      {
        path: "/agenda",
        name: "agenda",
        mini: "AG",
        component: Agenda,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/gestaoagenda",
        name: "agenda_management",
        mini: "GA",
        component: GestaoAgenda,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/dashboardagenda",
        name: "dashboard",
        mini: "DA",
        component: DashboardAgenda,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/bloqueioagenda",
        name: "calendar_lock",
        mini: "BA",    
        component: BloqueioAgenda,
        layout: "/adminclinic",
        showmenu: true
      },
    ]
  },  
  {
    collapse: true,
    name: "clients_management",
    icon: SupervisedUserCircleIcon,
    state: "clientesCollapse",
    views: [
      {
        path: "/gestaoclientes",
        name: "clients",
        mini: "GC",
        component: GestaoClienteList,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/gestaoleads",
        name: "leads",
        mini: "LD",
        component: GestaoLeads,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/gestaoListaRestricoes",
        name: "black_list",
        mini: "LN",
        component: GestaoListaNegraList,
        layout: "/adminclinic",
        showmenu: true
      },
    ]
  },
  {
    collapse: true,
    name: "professional",
    icon: DateRange,
    state: "profissionaisCollapse",
    views: [
      {
        path: "/cadastroprofissional",
        name: "professional_register",
        mini: "CP",
        component: ProfissionalList,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/cadastroexpediente",
        name: "expedients_register",
        mini: "CE",
        component: ExpedienteList,
        layout: "/adminclinic",
        showmenu: true
      }
    ]
  },{
    collapse: true,
    name: "stock",
    icon: WidgetsIcon,
    state: "estoqueCollapse",
    views: [
      {
        path: "/pedidocompra",
        name: "purchase_order",
        mini: "PC",
        component: PedidoCompra,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/gestaopedidocompra",
        name: "order_management",
        mini: "GP",
        component: GestaoPedidoCompra,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/recebimentocompra",
        name: "stock_entry",
        mini: "EE",
        component: RecebimentoCompra,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/ajusteestoque",
        name: "stock_adjustment",
        mini: "AE",
        component: AjusteEstoque,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/cadastrofornecedor",
        name: "supplier_register",
        mini: "CF",
        component: FornecedorList,
        layout: "/adminclinic",
        showmenu: true
      },
    ]
  },
  {
    collapse: true,
    name: "royalties",
    icon: Money,
    state: "royaltiesgCollapse",
    views: [
      {
        path: "/fechamentoroyalties",
        name: "closing_royalties",
        mini: "CF",
        component: RoyaltiesList,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/extratoroyalties",
        name: "",
        mini: "ER",
        component: ExtratoRoyalties,
        layout: "/adminclinic",
        showmenu: false
      },
    ]
  },
  {
    collapse: true,
    name: "CRM",
    icon: SupervisedUserCircleIcon,
    state: "CRMCollapse",
    views: [
      {
        path: "/gestaoCampanhas",
        name: "campaigns",
        mini: "GC",
        component: GestaoCampanhaList,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/acompanhamentoCampanhas",
        name: "follow_up",
        mini: "GA",
        component: AcompanhamentoCampanha,
        layout: "/adminclinic",
        showmenu: true
      }
    ]
  },
  {
    collapse: true,
    name: "reporting",
    icon: Description,
    state: "relatoriosCollapse",
    views: 
    [
      {
          path: "/relPersonalizados",
          name: "custom_reports",
          mini: "RP",        
          component: RelatoriosPersonalizadosList,
          layout: "/adminclinic",
          showmenu: true
      },
      {
        path: "/relSistema",
        name: "system_reports",   
        mini: "RS",     
        component: RelatoriosSistemaList,
        layout: "/adminclinic",
        showmenu: true
      }  
    ]
  },
  {
    collapse: true,
    name: "settings",
    icon: Settings,
    state: "configCollapse",
    views: [
      {
        path: "/cadastroprodutogrupos",
        name: "product_group_register",
        mini: "GP",
        component: ProdutoGrupo,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/cadastroprodutos",
        name: "product_register",
        mini: "P",
        component: Produto,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/cadastroespecialidade",
        name: "specialty_register",
        mini: "CE",
        component: EspecialidadeList,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/cadastroservico",
        name: "service_register",
        mini: "CS",
        component: ServicoList,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/cadastropacote",
        name: "package_register",
        mini: "CP",
        component: PacoteList,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/cadastrosmtp",
        name: "registration_smtp",
        mini: "SP",
        component: SMTPForm,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/cadastroprofissao",
        name: "profession_register",
        mini: "CP",
        component: ProfissaoList,
        layout: "/adminclinic",
        showmenu: true
      },
      {
        path: "/cadastroChavePIX",
        name: "registration_chave_pix",
        mini: "PX",
        component: CadastroChavePix,
        layout: "/adminclinic",
        showmenu: false,
      },
    ]
  },
  {
    path: "/controlefinanceiro",
    name: "financial",
    icon: LocalAtmIcon,
    component: ControleFinanceiro,
    layout: "/adminclinic",
    showmenu: true
  },
  {
    path: "/usuarios",
    name: "safety",
    icon: VerifiedUserIcon,
    component: UsuarioList,
    layout: "/adminclinic",
    showmenu: true
  },
  {
    path: "/accessdenied",
    name: "",
    icon: VerifiedUserIcon,
    component: AccessDenied,
    layout: "/adminclinic",
    showmenu: false
  }
];
export default Routes;
